import React, { useState } from "react"
import "semantic-ui-css/semantic.min.css"

import UnlinkedFilter from "./UnlinkedFilter"
import DateFilter from "./DateFilter"
import AmountFilter from "./AmountFilter"

const FilterButtonsInvoices = ({
  onInvoicesAmountFilterChange,
  onInvoicesDateFilterChange,
} = {}) => {
  const [activeFilter, setActiveFilter] = useState(null)
  // const [unlinked, setUnlinkedState] = useState(false)

  const handleFilterToggle = (filter) => {
    if (activeFilter === filter) {
      setActiveFilter(null)
    } else {
      setActiveFilter(filter)
    }
  }

  return (
    <React.Fragment>
      <UnlinkedFilter />
      <AmountFilter
        onAmountFilterChange={onInvoicesAmountFilterChange}
        // isOpen={activeFilter === "amount"}
        // onToggle={() => handleFilterToggle("amount")}
      />
      <DateFilter
        onDateFilterChange={onInvoicesDateFilterChange}
        isOpen={activeFilter === "date"}
        onToggle={() => handleFilterToggle("date")}
      />
    </React.Fragment>
  )
}

export default FilterButtonsInvoices
